import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { createStore, applyMiddleware } from 'redux'
import reducer from './../freighter/reducers/index'
import thunk from 'redux-thunk'
import { BrowserRouter } from 'react-router-dom'
import Main from './../freighter/components/main'

let createStoreWithMiddleware = applyMiddleware(thunk)(createStore)
let store = process.env.NODE_ENV !== 'production' ? createStoreWithMiddleware(reducer, window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__()) : createStoreWithMiddleware(reducer)

// adding signature
const cssRule =
	"color: rgb(249, 162, 34);" +
	"font-size: 60px;" +
	"font-weight: bold;" +
	"text-shadow: 1px 1px 5px rgb(249, 162, 34);" +
	"filter: dropshadow(color=rgb(249, 162, 34), offx=1, offy=1);"
setTimeout(console.log.bind(console, "%cBlogVault", cssRule), 0)
setTimeout(console.log.bind(console, "Yes, we are hiring!\nhttps://blogvault.net/careers/"), 0)

const appElement = document.getElementById('app')
appElement.textContent = ''
const root = createRoot(appElement)

root.render(
	<Provider store={store}>
		<BrowserRouter>
			<Main/>
		</BrowserRouter>
	</Provider>
)
